import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=a2dc7544&scoped=true&"
import script from "./PageMenu.vue?vue&type=script&lang=js&"
export * from "./PageMenu.vue?vue&type=script&lang=js&"
import style0 from "./PageMenu.vue?vue&type=style&index=0&id=a2dc7544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc7544",
  null
  
)

export default component.exports